import { radioComponentProps } from '../../utils/component';
import { RadioProps, RadioReturnType } from './radio.types';

export const radioProps = (props: RadioProps): RadioReturnType => {
  const { color = 'primary' } = props;

  const defaultProps =
    radioComponentProps[color] ?? radioComponentProps['primary'];
  const containerProps =
    radioComponentProps[`${color}Container`] ??
    radioComponentProps['primaryContainer'];

  return {
    input: defaultProps as string,
    container: containerProps as string
  };
};
